import { Farm } from "protos/farm/farm";
import { Section } from "portal/components/map/navigation/Section";
import { SelectionButton } from "portal/components/map/navigation/SelectionButton";
import { useTranslation } from "react-i18next";
import React, { FC, PropsWithChildren } from "react";

interface SelectionPanelProps extends PropsWithChildren {
  farms: Farm[];
  selectedFarmId: string | undefined;
  setSelectedFarmId: (id: string | undefined) => void;
}
export const SelectionPanel: FC<SelectionPanelProps> = ({
  farms,
  selectedFarmId,
  setSelectedFarmId,
  children,
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-2">
      <Section header={t("views.autotractor.selection.farms")}>
        <div className="flex flex-col h-full overflow-y-auto">
          {farms.map((farm) => (
            <SelectionButton
              key={farm.id?.id}
              isSelected={farm.id?.id === selectedFarmId}
              onClick={() => setSelectedFarmId(farm.id?.id)}
            >
              {farm.name}
            </SelectionButton>
          ))}
        </div>
      </Section>
      <Section header={t("views.autotractor.selection.tractors")}>
        <div className="flex flex-col h-full overflow-y-auto">{children}</div>
      </Section>
    </div>
  );
};
